module.exports = __webpack_public_path__ + "static/media/Group3564.76d8ea19.svg";